var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBlueDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3073_31411)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#DAFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C13.3138 4 16 6.6862 16 10C16 13.3138 13.3138 16 10 16C6.6862 16 4 13.3138 4 10C4 6.6862 6.6862 4 10 4ZM7.7878 11.6686C7.1614 11.1676 6.3118 10.9738 5.323 11.0854C5.53287 11.9869 5.99863 12.8087 6.66429 13.4519C7.32995 14.0951 8.16719 14.5324 9.0754 14.7112C8.9596 13.1362 8.4418 12.1906 7.7878 11.6686ZM12.2122 11.6686C11.5582 12.1918 11.0404 13.1362 10.9246 14.7106C11.8326 14.5317 12.6697 14.0945 13.3352 13.4514C14.0008 12.8083 14.4665 11.9867 14.6764 11.0854C13.6882 10.9738 12.8386 11.1676 12.2122 11.6686ZM10 8.8C9.43 8.8 8.9608 9.022 8.6164 9.2668L8.3176 9.475C8.0032 9.688 7.642 9.907 7.237 10.051C7.70991 10.1926 8.15128 10.4236 8.5372 10.7314C9.2116 11.2714 9.709 12.0436 10 13.0468C10.291 12.0436 10.7884 11.2708 11.4628 10.7314C11.8488 10.4238 12.2901 10.193 12.763 10.0516C12.358 9.907 11.9968 9.688 11.6824 9.475L11.3836 9.2668C11.0392 9.022 10.57 8.8 10 8.8ZM10 5.2C8.8817 5.20015 7.79853 5.59061 6.93735 6.30403C6.07617 7.01744 5.491 8.00906 5.2828 9.1078L5.257 9.2566L6.583 8.9914C6.9322 8.9218 7.264 8.7376 7.6348 8.4874L7.921 8.2882C8.3992 7.9486 9.1078 7.6 10 7.6C10.8328 7.6 11.5054 7.9036 11.98 8.2204L12.3652 8.4874C12.6892 8.7064 12.9844 8.8744 13.2868 8.9602L13.417 8.9914L14.743 9.2566C14.5655 8.12616 13.9902 7.09626 13.1206 6.3525C12.2509 5.60874 11.1443 5.20003 10 5.2Z",
    fill: "#7CD4FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3073_31411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBlueDriver);
export default __webpack_public_path__ + "static/media/lightBlueDriver.db7f805a0198f14a179ec4d5d4287664.svg";
export { ForwardRef as ReactComponent };